import { adjustIntervalAndValueTypesForFormState } from 'App/data-export/store/actions/_utils/adjustIntervalAndValueTypesForFormState'
import type { TDataExportStoreState } from 'App/data-export/store/dataExportStore'
import { dataExportStore, initialState } from 'App/data-export/store/dataExportStore'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'

export const actions = {
  openModal: () => {
    dataExportStore.setState(() => ({ ...initialState, visible: true }))
  },
  closeModal: () => {
    dataExportStore.setState(() => initialState)
  },
  setFormErrors: (formErrors: TDataExportStoreState['formErrors']) => {
    dataExportStore.setState((s) => ({
      ...s,
      formErrors: formErrors,
    }))
  },
  changePropertyId: (propertyId: TDataExportStoreState['formState']['propertyId']) => {
    dataExportStore.setState((s) => ({
      ...s,
      formErrors: initialState.formErrors,
      formState: {
        ...initialState.formState,
        dateRange: s.formState.dateRange,
        propertyId: propertyId,
      },
    }))
  },
  changeBlockIds: (blockIds: TDataExportStoreState['formState']['blockIds']) => {
    dataExportStore.setState((s) => {
      const newFormState = { ...s.formState, blockIds }

      const formState = adjustIntervalAndValueTypesForFormState({
        formState: newFormState,
        fieldAssetStoreState: fieldAssetStore.getState(),
      })

      return {
        ...s,
        formErrors: initialState.formErrors,
        formState: formState,
      }
    })
  },
  changePoints: (points: TDataExportStoreState['formState']['points']) => {
    dataExportStore.setState((s) => {
      const newFormState = { ...s.formState, points }

      const formState = adjustIntervalAndValueTypesForFormState({
        formState: newFormState,
        fieldAssetStoreState: fieldAssetStore.getState(),
      })

      return {
        ...s,
        formErrors: initialState.formErrors,
        formState: formState,
      }
    })
  },
  changeIrrigationZoneEmitterIds: (
    irrigationZoneEmitterIds: TDataExportStoreState['formState']['irrigationZoneEmitterIds'],
  ) => {
    dataExportStore.setState((s) => {
      const newFormState = { ...s.formState, irrigationZoneEmitterIds }

      const formState = adjustIntervalAndValueTypesForFormState({
        formState: newFormState,
        fieldAssetStoreState: fieldAssetStore.getState(),
      })

      return {
        ...s,
        formErrors: initialState.formErrors,
        formState: formState,
      }
    })
  },
  changeInterval: (interval: NonNullable<TDataExportStoreState['formState']['interval']>) => {
    dataExportStore.setState((s) => {
      const newFormState = { ...s.formState, interval }

      const formState = adjustIntervalAndValueTypesForFormState({
        formState: newFormState,
        fieldAssetStoreState: fieldAssetStore.getState(),
      })

      return {
        ...s,
        formErrors: initialState.formErrors,
        formState: formState,
      }
    })
  },
  changeDateRange: (dateRange: TDataExportStoreState['formState']['dateRange']) => {
    dataExportStore.setState((s) => ({
      ...s,
      formErrors: initialState.formErrors,
      formState: { ...s.formState, dateRange: dateRange },
    }))
  },
  changeValueTypes: (valueTypes: TDataExportStoreState['formState']['valueTypes']) => {
    dataExportStore.setState((s) => ({
      ...s,
      formErrors: initialState.formErrors,
      formState: { ...s.formState, valueTypes: valueTypes },
    }))
  },
}
